import type { TAppUser } from '@core/backend'
import { getUser } from './getUser'
import { toAppUser } from '../helpers/toAppUser'

/**
 * Loads the signed-in user (`/me` → `TAppUser`). This is the query function behind
 * `SessionQueryKey.me()`, not a call site — reach it through `fetchSessionUser` so the read goes
 * through the cache. Throws on failure; a 401 is handled centrally by the http-client.
 */
export const fetchCurrentUser = async (): Promise<TAppUser> => toAppUser(await getUser())
